import { render, staticRenderFns } from "./nodeDetail.vue?vue&type=template&id=52a07adb&scoped=true&"
import script from "./nodeDetail.vue?vue&type=script&lang=js&"
export * from "./nodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./nodeDetail.vue?vue&type=style&index=0&id=52a07adb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a07adb",
  null
  
)

export default component.exports